import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { type LandingPageState } from "../../types/state";
import { ReducerEntityPrefixTypes, ReducerNamespaceTypes } from "enums";
import { type LandingPageFormFields, type BodyContent } from "../../Details/types";

const initialState: LandingPageState = {
  landingPage: {
    html: "",
    contentUrlWithSas: "",
  },
  isLoading: false,
  isLoaded: false,
};

const landingPageSlice = createSlice({
  name: `${ReducerNamespaceTypes.Library}/${ReducerEntityPrefixTypes.ThreatDefenceCampaigns}/landingPage`,
  initialState,
  reducers: {
    saveLandingPage(state: LandingPageState, action: PayloadAction<LandingPageFormFields>) {
      state.landingPage.html = action.payload.html;
      state.landingPage.contentUrlWithSas = action.payload.contentUrlWithSas;
    },
    clearLandingPage: () => initialState,
    reqContent(state) {
      state.isLoading = true;
    },
    gotContent(state, action: PayloadAction<BodyContent>) {
      state.isLoading = false;
      state.isLoaded = true;
      state.landingPage.html = action.payload.html;
      state.landingPage.contentUrlWithSas = action.payload.contentUrlWithSas;
    },
    errContent(state, action: PayloadAction<Error>) {
      state.isLoading = false;
      state.error = action.payload;
    },
    setIsContentLoaded(state, action: PayloadAction<boolean>) {
      state.isLoaded = action.payload;
    },
  },
});

export const { saveLandingPage, clearLandingPage, reqContent, gotContent, errContent, setIsContentLoaded } =
  landingPageSlice.actions;

export default landingPageSlice.reducer;
